import { RenderPageCtx } from 'datocms-plugin-sdk';
import { Canvas } from 'datocms-react-ui';
import HierarchicPieChart, { ValueType } from './HierarchicPieChart';
import { GraphQLClient } from 'graphql-hooks';
import { useGQLQueryMultipleRecordsWithClient } from '../hooks/useGQLQueryWithClient';

const tags: { [key: string]: Set<string> } = {
  "Age groups": new Set([
    "Teen (14-18)",
    "Young Adult (18-29)",
    "Adult (30-45)",
    "Menopause (45-55)",
    "Post-Menopause (55+)",
  ]),

  "Cycle state": new Set([
    "Menstruation",
    "Follicular Phase",
    "Ovulation",
    "Luteal Phase",
  ]),

  "Contraception modes": new Set([
    "EC",
    "OC",
    "Patch ",
    "Other Contaceptives",
  ]),

  "Health issues": new Set([
    "Autoimmune",
    "Bone Health",
    "Breast Health",
    "Diabetes",
    "Hormones",
    "Cancer",
    "Eating",
    "Endometriosis",
    "Hair loss",
    "Heart related",
    "General Medical",
    "PCOS",
    "HPV",
    "Fertility",
    "UTI",
    "Mental Health",
    "Violence",
    "Conceiving / Fertility",
  ]),

  "General Topics": new Set([
    "Reproductive Health Rights",
    "Sex",
    "Relationship",
    "Sport",
    "Stress",
    "Fertility modul esetén mutassuk:",
    "Postpartum",
    "Pregnancy Loss",
    "Career and parenting",
    "First Trimester",
    "Second Trimester",
    "Third Trimester",
  ]),

  "Tag missing": new Set([""]),

  "Parenting": new Set([
    "Adoption",
    "Parenting with a newborn",
    "Parenting with an infant",
    "Parenting with a toddler",
    "Parenting with a pre-scholer",
    "Parenting with a school-aged child",
    "Parenting with a teens",
  ]),
}

function getCategoryOfTag(label: string): string {
  for (const category in tags) {
    if (tags[category].has(label)) {
      return category;
    }
  }
  return "Uncategorized";
}

type Props = {
  type: "Stories" | "Articles";
  style? : React.CSSProperties | undefined;
};

export default function TagDistributionGraph({ type, style }: Props) {
  function getArticleTags({ first, skip }: { first: number, skip: number }) {
    return `
      query WebshopArticleMarketigInfo {
        all${type}(
          first: ${first},
          skip: ${skip}
        )
        {
          tags
        }
      }
    `;
  }

  const client = new GraphQLClient({
    url: "https://graphql.datocms.com/",
    headers: {
      "Authorization": `Bearer c2637bf4c3ca322961249cf1b65310`, // Todo use user token
      "X-Include-Drafts": "true",
    }
  });

  const { loading, error, data } = useGQLQueryMultipleRecordsWithClient(client, getArticleTags, 100);

  if (loading) return <div> Loading data </div>
  if (error) return <div> Data loading error </div>

  const values: ValueType = {};
  for (const i of data) {
    const tag = i.tags;
    const category = getCategoryOfTag(tag);
    if (!values[category]) values[category] = {};
    if (!values[category][tag]) values[category][tag] = 0;
    values[category][tag]++;
  }

  return <HierarchicPieChart values={values} title={type} style={style} />
}
